import { Box } from "@chakra-ui/react";
import * as React from "react";

function UpstreamLeasedAssetsPreview() {
  return (
    <Box>
    </Box>
  );
}

export default UpstreamLeasedAssetsPreview;